<template>
  <div class="site-footer bg-[#1c3b3b] pt-[6.875rem] text-[#e9ecec]">
    <div class="max-w-[1200px] mx-auto">
      <div class="flex justify-between flex-wrap mb-[17px]">
        <!--left-->
        <div>
          <!--logo-->
          <div class="max-w-[225px] mb-[25px]">
            <img src="@/assets/logo-footer.svg" alt="" class="w-auto h-[80px]">
          </div>

          <div class="conus">
            <div class="text-[16px] font-bold leading-[25px] mb-1">
              {{ $t("footer.info.cs.name") }}
            </div>
            <div class="mb-[29px] text-white">
              {{ $t("footer.info.cs.mail") }}
            </div>
          </div>

          <div class="conus">
            <div class="text-[16px] font-bold leading-[25px] mb-[15px]">
              {{ $t("footer.info.contacts.name") }}
            </div>
            <div class="flex items-center justify-start mb-[28px]">
              <a href="https://wa.me/15859695678" rel="nofollow" target="_blank" class="cursor-pointer no-underline"><img src="@/assets/img/footer/foot1.png" alt="" class="w-[48px] h-[48px] mr-[19px]"></a>
              <a href="https://twitter.com/share?text=Sparkproxy&url=https://www.sparkproxy.com" rel="nofollow" target="_blank" class="cursor-pointer no-underline">
                <img src="@/assets/index/img/index/icons8-twitterx.svg" alt="" class="w-[48px] h-[48px] mr-[19px] invert"></a>
              <a href="https://t.me/+QTlIZobvM0wwMTZl" rel="nofollow" target="_blank" class="cursor-pointer no-underline"><img src="@/assets/img/footer/foot3.png" alt="" class="w-[48px] h-[48px] mr-[19px]"></a>
            </div>
          </div>
        </div>

        <!--right-->
        <div class="flex justify-between flex-wrap item-start w-[780px]">
          <ul v-for="ac in article_columns">
            <li><span class="text-[16px] leading-[25px] mb-[23px] inline-block">{{ac.column}}</span></li>

            <li v-for="article in ac.articles">
              <a :href="article.link" target="_blank" class="text-[16px] leading-[25px] opactiy-50 mb-[20px] inline-box">{{article.title}}</a>
            </li>
          </ul>
          
        </div>
      </div>
      <!--foottips-->
      <div class="hidden flex justify-center item-center mb-[20px] text-[14px] text-[#ffffff80] text-center">Due to policy reasons,Proxy must be used in non-Mainland China Internet environment!</div>
    </div>  

    <!--line-->
    <div class="bg-[#ffffff80] h-[1px]"></div>

    <!-- bottom -->
    <div class="max-w-[1200px] mx-auto flex flex-col items-start justify-around flex-wrap min-h-[64px]">
      <!--top-->
      <div v-if="friendships.length > 0" class="text-[16px] leading-[25px] text-[#ffffff80]">
        <span>{{ $t("footer.friendships.title") }}</span>
        
        <template v-for="(friendship, index) in friendships">
          <a :key="index" class="text-[16px] leading-[25px] text-[#ffffff80]" :href="friendship.link" target="_blank" rel="noopener noreferrer">
            {{ friendship.name }}
          </a>
          <span v-if="index !== friendships.length - 1" class="mx-2"> / </span>
        </template>

      </div>
      <!--bottom-->
      <div class="flex justify-between items-center w-full">
        <div class="text-[16px] leading-[25px] text-[#ffffff80]">
          <span data-lang="footer_cont_xy2">{{ $t("footer.copyright") }}</span>
        </div>
        <div>
          <a href="/privacy/" target="_blank" class="text-[16px] leading-[25px] text-[#ffffff80] mr-[22px]">{{ $t("footer.privacy") }}</a>
          <a href="/terms/" target="_blank" class="text-[16px] leading-[25px] text-[#ffffff80] mr-[22px]">{{ $t("footer.terms") }}</a>
          <a href="javascript(0);" @click.prevent="emitEvent" target="_blank" class="text-[16px] leading-[25px] text-[#ffffff80] mr-[22px]">{{ $t("footer.cookies") }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../../event-bus';

export default {
  name: 'FooterBar',
  data() {
    return {      
    }
  },
  computed: {
    article_columns() {
      return this.$t("footer.article_columns")
    },
    friendships() {
      return this.$t("footer.friendships.links")
    }
  },
  methods: {
    emitEvent() {
      EventBus.$emit('showCookiePreferences', '');
    }
  },
}
</script>

<style scoped>
.theme-summer .site-footer,
.site-footer {
  background:
    radial-gradient(circle at 18% 24%, rgba(247, 201, 72, 0.14), transparent 24%),
    linear-gradient(180deg, #173b3a 0%, #1f3940 100%) !important;
}

.theme-summer .site-footer a:hover,
.site-footer a:hover {
  color: #ffb26b !important;
}
</style>
